var map = {
	"./black/quantijingyin.png": "qSJv",
	"./blue/quantijingyin.png": "CV7X",
	"./white/quantijingyin.png": "2L6H"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cdCl";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/quantijingyin\.png$
// module id = cdCl
// module chunks = 24